import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
};

export default new Router({
	routes: [
		// {
		// 	path: '/',
		// 	redirect: '/login'
		// },
		// {
		// 	path: '/',
		// 	component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
		// 	meta: {
		// 		title: 'Home'
		// 	},
		// 	children: [
		// 		// 系统首页
		// 		{
		// 			path: '/dashboard',
		// 			component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Dashboard.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_0'
		// 			}
		// 		},
		// 		// 菜单管理
		// 		{
		// 			path: '/menusList',
		// 			component: () => import( /* webpackChunkName: "menusList" */ '../pages/menus/menusList.vue'),
		// 			meta: {
		// 				title: '菜单管理'
		// 			}
		// 		},
		// 		// 角色管理
		// 		{
		// 			name: 'rolesList',
		// 			path: '/rolesList',
		// 			component: () => import( /* webpackChunkName: "rolesList" */ '../pages/roles/rolesList.vue'),
		// 			meta: {
		// 				title: '角色管理'
		// 			}
		// 		},
		// 		// // 角色管理
		// 		// {
		// 		// 	name: 'rolesList',
		// 		//     path: '/rolesList',
		// 		//     component: () => import(/* webpackChunkName: "rolesList" */ '../pages/roles/rolesList.vue'),
		// 		//     meta: { title: '角色管理' }
		// 		// },
		// 		// 用户管理
		// 		{
		// 			name: 'usersList',
		// 			path: '/usersList',
		// 			component: () => import( /* webpackChunkName: "usersList" */ '../pages/users/usersList.vue'),
		// 			meta: {
		// 				title: 'sidebar.sidebar_3'
		// 			}
		// 		},
		// 		{
		// 			name: 'addUsers',
		// 			path: '/addUsers',
		// 			component: () => import( /* webpackChunkName: "addUsers" */ '../pages/users/addUsers.vue'),
		// 			meta: {
		// 				title: '用户新增'
		// 			}
		// 		},
		// 		{
		// 			name: 'editUsers',
		// 			path: '/editUsers',
		// 			component: () => import( /* webpackChunkName: "editUsers" */ '../pages/users/editUsers.vue'),
		// 			meta: {
		// 				title: '用户编辑'
		// 			}
		// 		},
		// 		{
		// 			name: 'usersDetails',
		// 			path: '/usersDetails',
		// 			component: () => import( /* webpackChunkName: "usersDetails" */ '../pages/users/usersDetails.vue'),
		// 			meta: {
		// 				title: '用户查看'
		// 			},
		// 		},
		// 		{
		// 			name: 'classesList',
		// 			path: '/classesList',
		// 			component: () => import( /* webpackChunkName: "classesList" */ '../pages/classes/classesList.vue'),
		// 			meta: {
		// 				title: '班级管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addClasses',
		// 			path: '/addClasses',
		// 			component: () => import( /* webpackChunkName: "addClasses" */ '../pages/classes/addClasses.vue'),
		// 			meta: {
		// 				title: '添加班级'
		// 			}
		// 		},
		// 		{
		// 			name: 'editClasses',
		// 			path: '/editClasses',
		// 			component: () => import( /* webpackChunkName: "editClasses" */ '../pages/classes/editClasses.vue'),
		// 			meta: {
		// 				title: '更新班级信息'
		// 			}
		// 		},
		// 		{
		// 			name: 'gradeList',
		// 			path: '/gradeList',
		// 			component: () => import( /* webpackChunkName: "gradeList" */ '../pages/grade/gradeList.vue'),
		// 			meta: {
		// 				title: '年级管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addGrade',
		// 			path: '/addGrade',
		// 			component: () => import( /* webpackChunkName: "addGrade" */ '../pages/grade/addGrade.vue'),
		// 			meta: {
		// 				title: '添加年级'
		// 			}
		// 		},
		// 		{
		// 			name: 'editGrade',
		// 			path: '/editGrade',
		// 			component: () => import( /* webpackChunkName: "editGrade" */ '../pages/grade/editGrade.vue'),
		// 			meta: {
		// 				title: '更新年级信息'
		// 			}
		// 		},
		// 		{
		// 			name: 'childList',
		// 			path: '/childList',
		// 			component: () => import( /* webpackChunkName: "childList" */ '../pages/child/childList.vue'),
		// 			meta: {
		// 				title: '宝宝管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addChild',
		// 			path: '/addChild',
		// 			component: () => import( /* webpackChunkName: "addChild" */ '../pages/child/addChild.vue'),
		// 			meta: {
		// 				title: '添加宝宝'
		// 			}
		// 		},

		// 		{
		// 			name: 'editChild',
		// 			path: '/editChild',
		// 			component: () => import( /* webpackChunkName: "editChild" */ '../pages/child/editChild.vue'),
		// 			meta: {
		// 				title: '更新宝宝信息'
		// 			}
		// 		},
		// 		//用户管理
		// 		{
		// 			name: 'parentList',
		// 			path: '/parentList',
		// 			component: () => import( /* webpackChunkName: "parentList" */ '../pages/parent/parentList.vue'),
		// 			meta: {
		// 				title: '家长管理'
		// 			}
		// 		},
		// 		// {
		// 		// 	name: 'addUsers',
		// 		//     path: '/addUsers',
		// 		//     component: () => import(/* webpackChunkName: "addUsers" */ '../pages/users/addUsers.vue'),
		// 		//     meta: { title: '用户新增' }
		// 		// },

		// 		{
		// 			name: 'addParent',
		// 			path: '/addParent',
		// 			component: () => import( /* webpackChunkName: "addParent" */ '../pages/parent/addParent.vue'),
		// 			meta: {
		// 				title: '添加家长'
		// 			}
		// 		},
		// 		{
		// 			name: 'editParent',
		// 			path: '/editParent',
		// 			component: () => import( /* webpackChunkName: "editParent" */ '../pages/parent/editParent.vue'),
		// 			meta: {
		// 				title: '更新家长信息'
		// 			}
		// 		},
		// 		{
		// 			name: 'monitorCAAList',
		// 			path: '/monitorCAAList',
		// 			component: () => import( /* webpackChunkName: "monitorCAAList" */ '../pages/monitorCAA/monitorCAAList.vue'),
		// 			meta: {
		// 				title: '视频管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addMonitorCAA',
		// 			path: '/addMonitorCAA',
		// 			component: () => import( /* webpackChunkName: "addMonitorCAA" */ '../pages/monitorCAA/addMonitorCAA.vue'),
		// 			meta: {
		// 				title: '添加视频'
		// 			}
		// 		},
		// 		{
		// 			name: 'editMonitorCAA',
		// 			path: '/editMonitorCAA',
		// 			component: () => import( /* webpackChunkName: "editMonitorCAA" */ '../pages/monitorCAA/editMonitorCAA.vue'),
		// 			meta: {
		// 				title: '更新视频信息'
		// 			}
		// 		},
		// 		{
		// 			name: 'monitorCFLList',
		// 			path: '/monitorCFLList',
		// 			component: () => import( /* webpackChunkName: "monitorCFLList" */ '../pages/monitorCFL/monitorCFLList.vue'),
		// 			meta: {
		// 				title: '视频类别管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addMonitorCFL',
		// 			path: '/addMonitorCFL',
		// 			component: () => import( /* webpackChunkName: "addMonitorCFL" */ '../pages/monitorCFL/addMonitorCFL.vue'),
		// 			meta: {
		// 				title: '添加视频类别'
		// 			}
		// 		},
		// 		{
		// 			name: 'editMonitorCFL',
		// 			path: '/editMonitorCFL',
		// 			component: () => import( /* webpackChunkName: "editMonitorCFL" */ '../pages/monitorCFL/editMonitorCFL.vue'),
		// 			meta: {
		// 				title: '更新视频类别'
		// 			}
		// 		},
		// 		{
		// 			name: 'departmentList',
		// 			path: '/departmentList',
		// 			component: () => import( /* webpackChunkName: "departmentList" */ '../pages/department/departmentList.vue'),
		// 			meta: {
		// 				title: '部门管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addDepartment',
		// 			path: '/addDepartment',
		// 			component: () => import( /* webpackChunkName: "addDepartment" */ '../pages/department/addDepartment.vue'),
		// 			meta: {
		// 				title: '添加部门'
		// 			}
		// 		},
		// 		{
		// 			name: 'editDepartment',
		// 			path: '/editDepartment',
		// 			component: () => import( /* webpackChunkName: "editDepartment" */ '../pages/department/editDepartment.vue'),
		// 			meta: {
		// 				title: '更新部门信息'
		// 			}
		// 		},
		// 		{
		// 			name: 'classroomList',
		// 			path: '/classroomList',
		// 			component: () => import( /* webpackChunkName: "classroomList" */ '../pages/classroom/classroomList.vue'),
		// 			meta: {
		// 				title: '教室管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addClassroom',
		// 			path: '/addClassroom',
		// 			component: () => import( /* webpackChunkName: "addClassroom" */ '../pages/classroom/addClassroom.vue'),
		// 			meta: {
		// 				title: '添加教室'
		// 			}
		// 		},
		// 		{
		// 			name: 'editClassroom',
		// 			path: '/editClassroom',
		// 			component: () => import( /* webpackChunkName: "editClassroom" */ '../pages/classroom/editClassroom.vue'),
		// 			meta: {
		// 				title: '更新教室信息'
		// 			}
		// 		},
		// 		{
		// 			name: 'teacherList',
		// 			path: '/teacherList',
		// 			component: () => import( /* webpackChunkName: "teacherList" */ '../pages/teacher/teacherList.vue'),
		// 			meta: {
		// 				title: '园丁管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addTeacher',
		// 			path: '/addTeacher',
		// 			component: () => import( /* webpackChunkName: "addTeacher" */ '../pages/teacher/addTeacher.vue'),
		// 			meta: {
		// 				title: '添加园丁'
		// 			}
		// 		},
		// 		{
		// 			name: 'editTeacher',
		// 			path: '/editTeacher',
		// 			component: () => import( /* webpackChunkName: "editTeacher" */ '../pages/teacher/editTeacher.vue'),
		// 			meta: {
		// 				title: '更新园丁信息'
		// 			}
		// 		},
		// 		{
		// 			name: 'gardenList',
		// 			path: '/gardenList',
		// 			component: () => import( /* webpackChunkName: "gardenList" */ '../pages/garden/gardenList.vue'),
		// 			meta: {
		// 				title: '幼儿园管理'
		// 			}
		// 		},
		// 		{
		// 			name: 'addGarden',
		// 			path: '/addGarden',
		// 			component: () => import( /* webpackChunkName: "addGarden" */ '../pages/garden/addGarden.vue'),
		// 			meta: {
		// 				title: '添加幼儿园'
		// 			}
		// 		},
		// 		{
		// 			name: 'editGarden',
		// 			path: '/editGarden',
		// 			component: () => import( /* webpackChunkName: "editGarden" */ '../pages/garden/editGarden.vue'),
		// 			meta: {
		// 				title: '更新幼儿园信息'
		// 			}
		// 		},
		// 		// {
		// 		// 	name: 'editGarden',
		// 		// 	path: '/editGarden',
		// 		// 	component: () => import(/* webpackChunkName: "editGarden" */ '../pages/garden/editGarden.vue'),
		// 		// 	meta: { title: '更新幼儿园信息' }
		// 		// },

		// 		// {
		// 		//     path: '/editChild',
		// 		//     component: () => import(/* webpackChunkName: "editChild" */ '../pages/child/editChild.vue'),
		// 		//     meta: { title: 'editChild' }
		// 		// },
		// 	]
		// },
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "login" */ '../pages/Login.vue'),
			meta: {
				title: 'login.login_1'
			}
		},
		{
			path: '/forgetPwd',
			component: () => import( /* webpackChunkName: "forgetPwd" */ '../pages/forgetPwd.vue'),
			meta: {
				title: 'forgetPwd'
			}
		},
		{
			path: '/404',
			component: () => import( /* webpackChunkName: "forgetPwd" */ '../pages/404.vue'),
			meta: {
				title: '404'
			}
		}
	]
});
